import moment from "moment";
import Icon from "@mdi/react";
import { useState } from "react";
import { mdiPlus } from "@mdi/js";
import { Link, useTitle } from "easy-page-router/react";

import { useHeaders, useSSRHook } from "../../ssrh/client";
import { useUser } from "../User";
import Carousel from "../components/Carousel";
import { Loading, Remove, Separator } from "../components";
import EditNew from "../components/EditNew";
import { api } from "../services/api";

import { New } from "../../types";
import LastProjects from "../components/LastProjects";
import Footer from "../components/Footer";

const emptyNew: New = {
    _id: "",
    title: "",
    date: moment().format("YYYY-MM-DD"),
    content: "",
};

export default function News() {
    const user = useUser();

    const [news, error, isLoading, reload] = useSSRHook<New[]>("/api/news");

    const title = "Aktuality | TSO Krkonoše";
    useTitle(title);
    useHeaders({
        title,
        description: "Aktuality pro technický svazek obcí Krokonoše",
        image: window.location.origin + "/logo.png",
        canonical: window.location.origin + window.location.pathname,
    });

    const [newNews, setNewNews] = useState<null | New>(null);

    async function handleRemove(id: string) {
        await api.removeNews({ newsId: id });
        reload();
    }

    return <>
        <main>
            <Carousel>
                <div className="big-logo" />
            </Carousel>
            <div className="content">
                <section>
                    <div className="page">
                        <h1>Aktuality</h1>
                        <Separator />

                        {user.isAdmin && (
                            <div className="admin">
                                <button onClick={() => setNewNews(emptyNew)}>
                                    <Icon path={mdiPlus} size={1} />Přidat
                                    aktualitu
                                </button>
                                <EditNew
                                    value={newNews}
                                    onClose={() => setNewNews(null)}
                                    onChange={() => {
                                        reload();
                                        setNewNews(null);
                                    }}
                                />
                            </div>
                        )}

                        {isLoading && <Loading />}
                        {error && (
                            <p className="alert">
                                Aktuality se bohužel nepodařili načíst 🙁
                            </p>
                        )}
                        {news && (
                            <div className="list">
                                {news?.map((n) => (
                                    <div key={n._id} className="item">
                                        <div className="date">
                                            <div className="content">
                                                <div className="day">
                                                    {moment(n.date).format("D")}
                                                </div>
                                                <div className="month">
                                                    {moment(n.date).format(
                                                        "MMMM",
                                                    )}
                                                </div>
                                                <div className="year">
                                                    {moment(n.date).format(
                                                        "YYYY",
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="content">
                                            <h2>
                                                <Link to={`/aktualita/${encodeURIComponent(n._id)}`}>
                                                    {n.title}
                                                </Link>
                                            </h2>
                                            <p>{n.content}</p>
                                        </div>
                                        <div className="more">
                                            <Link
                                                to={`/aktualita/${encodeURIComponent(n._id)
                                                    }`}
                                            >
                                                Více
                                            </Link>
                                            {user.isAdmin && (
                                                <Remove
                                                    onRemove={() =>
                                                        handleRemove(n._id)}
                                                />
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </section>
            </div>
            <LastProjects />
        </main>
        <Footer />
    </>;
}
